var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_42_1",
    "data-name": "Component 42 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 36,
    height: 36,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    d: "M.392,24.977,0,5.676a2.266,2.266,0,0,1,.63-1.615L4.525,0l3.91,4.078a2.266,2.266,0,0,1,.631,1.575L9.011,24.937A2.266,2.266,0,0,1,6.744,27.2H2.658A2.266,2.266,0,0,1,.392,24.977Z",
    transform: "translate(15.476 28.442) rotate(-135)",
    fill: "#feb730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-57",
    d: "M18.469,2a1.511,1.511,0,0,1,0,3.022H8.044A3.022,3.022,0,0,0,5.022,8.044V26.175A3.022,3.022,0,0,0,8.044,29.2H26.175A3.022,3.022,0,0,0,29.2,26.175V18.621a1.511,1.511,0,1,1,3.022,0v7.555a6.044,6.044,0,0,1-6.044,6.044H8.044A6.044,6.044,0,0,1,2,26.175V8.044A6.044,6.044,0,0,1,8.044,2Z",
    transform: "translate(1.022 0.8)",
    fill: "#feb730",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOr);
export default __webpack_public_path__ + "static/media/edit_or.b7a3f0c239add841ed23fb25cb57c2af.svg";
export { ForwardRef as ReactComponent };